import { Button, Tooltip } from "@material-ui/core";
import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import { Icon } from "react-icons-kit";
import { eye } from "react-icons-kit/feather/eye";
import { eyeOff } from "react-icons-kit/feather/eyeOff";
import { FormattedMessage, injectIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { login } from "./authSlice";
import { httpService } from "../../base/services/httpService.service";
import BlockUI from "../../base/components/BlockUI";
import { ReactComponent as GoogleIcon } from "../../assets/icons/google-icon.svg";
import { ReactComponent as FacebookIcon } from "../../assets/icons/facebook-icon.svg";
import "./custom.css";
import "./style.scss";

const initialValues = {
   email: "",
   password: ""
};

function Login() {
   const { isLoading } = useSelector((state) => state.auth);
   const dispatch = useDispatch();

   const [type, setType] = useState("password");
   const [icon, setIcon] = useState(eyeOff);

   const navigate = useNavigate();

   const LoginSchema = Yup.object().shape({
      email: Yup.string()
         .email("Invalid email")
         .required("Required"),
      password: Yup.string()
         .max(50, "Maximum 50 symbols")
         .required("Required")
   });

   const handleToggle = () => {
      if (type === "password") {
         setIcon(eye);
         setType("text");
      } else {
         setIcon(eyeOff);
         setType("password");
      }
   };

   const submitForm = (values) => {
      dispatch(login(values, successCallback, errCB));
   };

   const successCallback = () => {
      navigate("/admin/workspace");
   };

   const errCB = (data) => {
      if (data.target?.targetUrl) {
         navigate(data.target?.targetUrl, {
            state: { fromApp: true, data: data.target.params }
         });
      }
   };

   return (
      <div
         className="login-form login-signin padding"
         style={{ display: "block", marginLeft: "25%", padding: "5%" }}
      >
         <BlockUI isLoading={isLoading} />
         {/* begin::Head */}
         <div className="mb-10 mb-lg-20 text-center">
            <h3>Welcome Back</h3>
            <p>Login into your account</p>
         </div>
         {/* <div className="d-flex justify-content-center ">
            <div className="mb-lg-20  mx-5">
               <button className="google-button">
                  <GoogleIcon />
                  &nbsp;&nbsp;Google
               </button>
            </div>
            <div className="mb-lg-20 text-center">
               <button className="facebook-button">
                  <FacebookIcon />
                  &nbsp; Facebook
               </button>
            </div>
         </div> */}

         {/* <div className="d-flex align-items-center justify-content-around mb-10 line-container">
            <div className="line"></div>
            <p className="my-1">Or continue with</p>
            <div className="line"></div>
         </div> */}

         {/*begin::Form*/}
         <Formik
            initialValues={initialValues}
            validationSchema={LoginSchema}
            onSubmit={(values) => {
               submitForm(values);
            }}
         >
            {({ handleSubmit, handleChange, values, errors }) => (
               <form
                  onSubmit={handleSubmit}
                  className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
               >
                  <div className="form-group fv-plugins-icon-container">
                     <label>Email</label>
                     <input
                        className={`form-control h-auto py-5 px-6`}
                        type="email"
                        name="email"
                        onChange={handleChange}
                        values={values.email}
                     />
                     {errors.email && <div className="error-message">{errors.email}</div>}
                  </div>
                  <div className="form-group fv-plugins-icon-container">
                     <label>Password</label>
                     {/* <Tooltip title="Min 3 symbols">
                        <Button>?</Button>
                     </Tooltip> */}
                     <div className="password-section">
                        <input
                           className={`form-control h-auto py-5 px-6`}
                           type={type}
                           name="password"
                           onChange={handleChange}
                           values={values.password}
                        />
                        <span className="eyeButton" onClick={handleToggle}>
                           <Icon className="icon" icon={icon} size={20} />
                        </span>
                     </div>

                     {errors.password && <div className="error-message">{errors.password}</div>}
                  </div>
                  <div className="d-flex justify-content-between">
                     <label className="checkbox">
                        <Link
                           to="/terms"
                           target="_blank"
                           className="mr-1 r-btn"
                           rel="noopener noreferrer"
                        >
                           Remember me?
                        </Link>
                        <input type="checkbox" name="acceptTerms" className="m-1" />
                        <span />
                     </label>
                     <div className="d-flex">
                        <Link
                           to="/auth/forgot-password"
                           className="font-weight-bold ml-2 password-text"
                           id="kt_login_forgot"
                        >
                           <FormattedMessage id="AUTH.GENERAL.FORGOT_BUTTON" />
                        </Link>
                     </div>
                  </div>
                  <div className="form-group d-flex flex-wrap justify-content-center align-items-center">
                     <button
                        id="kt_login_signin_submit"
                        type="submit"
                        className={`btn sign-btn font-weight-bold px-25 py-4 my-3 mt-10`}
                     >
                        <span>SIGN IN</span>
                        {isLoading && <span className="ml-3 spinner spinner-white"></span>}
                     </button>
                  </div>
               </form>
            )}
         </Formik>
         {/*end::Form*/}
         <div className="d-flex justify-content-center">
            <span className="font-weight-bold text-dark-50">Don't have an account yet?</span>
            <Link
               to="/auth/registration"
               className="font-weight-bold ml-2 sign-up-btn"
               id="kt_login_signup"
            >
               Sign up!
            </Link>
         </div>
      </div>
   );
}

export default injectIntl(Login);
